<template>
  <div class="rotate-device">
    <div class="rotate-device__container">
      <img
        :src="RotateDevice"
        alt="Поверни устройство"
      >

      <span class="rotate-device__title">
        Поверни устройство
      </span>

      <span class="rotate-device__text">
        Игра работает только в вертикальной ориентации
      </span>
    </div>
  </div>
</template>

<script setup>
import RotateDevice from '@/assets/images/layout/rotate-device.webp';
</script>

<style lang="scss" scoped>
.rotate-device {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: $z-device-rotate;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(15px);
  display: none;
  color: $color-white;

  @media (hover: none)
    and (pointer: coarse)
    and (orientation: landscape) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__container {
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      margin-bottom: 4rem;
      width: 20.6rem;
      height: 19.7rem;
    }

    span {
      font-family: $font-default-name;
    }
  }

 &__title {
    font-size: 3.8rem;
    font-weight: $font-weight-bold;
    line-height: 105%;
    letter-spacing: -0.076rem;
    margin-bottom: 0.8rem;
  }

  &__text {
    font-size: 1.4rem;
    line-height: 115%;
    letter-spacing: -0.014rem;
  }
}
</style>
